module.exports = __webpack_public_path__ + "static/media/movein@2x.f6776704.png";